"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var change_type_1 = require("../../../core/cd/interface/change-type");
var state_1 = require("../trait/state");
exports.state = function (prototypeOrType, name) {
    if (!name) {
        return function (instance, name) {
            state_1.StateTrait.addState(instance.constructor, name, prototypeOrType);
        };
    }
    else {
        state_1.StateTrait.addState(prototypeOrType.constructor, name, change_type_1.ChangeType.DEEP);
    }
};
//# sourceMappingURL=state.js.map